export default __webpack_public_path__ + "static/media/brand-2.49a8bcef.png";